import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HashRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import ThemeContextProvider from './context/ThemeContext';

// MUI X date pickers + dayjs jalali setup
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import jalaliday from 'jalaliday';
import 'dayjs/locale/fa';

// فعال‌سازی jalali و تنظیم locale فارسی
dayjs.extend(jalaliday);
dayjs.locale('fa');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeContextProvider>
        <HashRouter>
          <App />
        </HashRouter>
      </ThemeContextProvider>
    </LocalizationProvider>
  </React.StrictMode>
);

reportWebVitals();

